module.exports = __webpack_public_path__ + "static/img/img_activity_c.919cfd10.png";